import { Listeners, getSiblings } from './utils';

class CosPasswordAfter extends HTMLElement {
  constructor() {
    super();
    this.listeners = new Listeners();
    this.settings = JSON.parse(this.getAttribute('data-settings')) || {};
    this.formInited = false;
  }

  connectedCallback() {
    if (this.settings.designMode) return this.handleDesignMode();

    this.currentSection = this.closest('.shopify-section');
    this.siblings = getSiblings(this.currentSection);

    const passwordSaved = localStorage.getItem(this.settings.storageId);

    if (!passwordSaved) this.handlePopup();
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  handlePopup() {
    this.removeSibilings();
    this.showPopup();
  }

  removeSibilings() {
    this.siblings.after.forEach((sibling) => {
      sibling.remove();
    });
  }

  addSibilings() {
    this.siblings.after.forEach((sibling) => {
      this.currentSection.parentElement.append(sibling);
    });
  }

  showPopup() {
    const popup = this.querySelector('cos-popup');
    if (!popup) return;

    popup.togglePopup(null, true);
    this.initForm();
  }

  hidePopup() {
    const popup = this.querySelector('cos-popup');
    if (!popup) return;

    popup.hidePopup();
  }

  initForm() {
    if (this.formInited) return;

    const form = this.querySelector('form');
    if (!form) return;

    this.listeners.add(form, 'submit', (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      const password = formData.get('password');
      const decoded = window.atob(this.settings.storageId);

      const input = form.querySelector('[name="password"]');
      if (!input) return;
      
      if (password === decoded) {        
        localStorage.setItem(this.settings.storageId, password);

        this.addSibilings();
        this.hidePopup();
      } else {
        input.setCustomValidity(this.settings.invalidMessage);
        input.reportValidity();

        setTimeout(() => {
          input.setCustomValidity('');
        }, 1400);
      }
    });

    this.formInited = true;
  }

  handleDesignMode() {
    this.listeners.add(document, 'shopify:section:select', (e) => {
      if (e.detail.sectionId !== this.settings.sectionId) return;

      this.showPopup();
    });
    this.listeners.add(document, 'shopify:section:load', (e) => {
      if (e.detail.sectionId !== this.settings.sectionId) return;

      this.showPopup();
    });
    this.listeners.add(document, 'shopify:section:deselect', (e) => {
      if (e.detail.sectionId !== this.settings.sectionId) return;

      this.hidePopup();
    });
    this.listeners.add(document, 'shopify:section:unload', (e) => {
      if (e.detail.sectionId !== this.settings.sectionId) return;

      this.hidePopup();
    });
  }
}
if (!customElements.get('cos-password-after'))  customElements.define('cos-password-after', CosPasswordAfter);